import { Text } from "@daangn/carotene";
import {
  IconChevronDownFill,
  IconLocationpinFill,
} from "@daangn/react-monochrome-icon";
import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import { GtmVariableName } from "~/utils/GtmVariable";

import * as css from "./SquareSelectRegionButton.css";

interface SquareSelectRegionButtonProps
  extends Exclude<HTMLAttributes<HTMLButtonElement>, "className" | "children"> {
  currentRegionName: string;
}

export const SquareSelectRegionButton = forwardRef<
  HTMLButtonElement,
  SquareSelectRegionButtonProps
>(({ currentRegionName, ...props }, ref) => (
  <button
    className={css.button}
    data-gtm={GtmVariableName.GnbLocation}
    {...props}
    ref={ref}
  >
    <IconLocationpinFill className={css.leftIcon} />
    <Text size="small" weight="strong" maxLines={1} color="neutral">
      {currentRegionName}
    </Text>
    <IconChevronDownFill className={css.expandIcon} size={14} />
  </button>
));

SquareSelectRegionButton.displayName = "SquareSelectRegionButton";
